import React, { useMemo } from "react";
import { useServiceMenu } from "../DeviceData/useServiceMenu";
import { ServiceMenuScreen } from "./ServiceMenuScreen";
var FilteredItem = {};

function filterServiceMenu(serviceMenuValue) {
  if (!serviceMenuValue) return serviceMenuValue;

  if (Array.isArray(serviceMenuValue)) {
    return serviceMenuValue.map(function (item) {
      return filterServiceMenu(item);
    }).filter(function (item) {
      return item != FilteredItem;
    });
  }

  if (Object.getPrototypeOf(serviceMenuValue) === Object.prototype) {
    if (serviceMenuValue.availableForUser === false) {
      return FilteredItem;
    }

    var hasValues = false;
    var hasFilteredValues = false;
    var mappedObj = Object.keys(serviceMenuValue).reduce(function (acc, key) {
      if (key === 'availableForUser') {
        return acc;
      }

      var mappedValue = filterServiceMenu(serviceMenuValue[key]);

      if (mappedValue !== FilteredItem) {
        acc[key] = mappedValue;
        hasValues = true;
      } else {
        hasFilteredValues = true;
      }

      return acc;
    }, {});
    return !hasValues && hasFilteredValues ? FilteredItem : mappedObj;
  }

  return serviceMenuValue;
}

export function UserServiceMenu(_ref) {
  var backTo = _ref.backTo,
      deviceScreens = _ref.deviceScreens,
      title = _ref.title,
      menuApi = _ref.menuApi;
  var serviceMenu = useServiceMenu();
  var userServiceMenu = useMemo(function () {
    return serviceMenu && filterServiceMenu(serviceMenu);
  }, [serviceMenu]);
  return /*#__PURE__*/React.createElement(ServiceMenuScreen, {
    title: title,
    serviceMenu: userServiceMenu,
    backTo: backTo,
    deviceScreens: deviceScreens,
    menuApi: menuApi
  });
}